import { render, staticRenderFns } from "./cate01.vue?vue&type=template&id=62b12e3e"
import script from "./cate01.vue?vue&type=script&lang=js"
export * from "./cate01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports